<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'service',
  components: {},
};
</script>
